import React from 'react';
import { LightbulbIcon } from 'lucide-react';
export function MethodSection() {
  return <section className="bg-[#faf5eb] text-slate-900 py-24 px-4 sm:px-6 lg:px-8" data-id="element-138">
      <div className="max-w-4xl mx-auto text-center" data-id="element-139">
        <div className="inline-flex items-center justify-center p-3 bg-amber-100 rounded-2xl mb-6" data-id="element-140">
          <LightbulbIcon className="w-8 h-8 text-amber-600" data-id="element-141" />
        </div>

        <h2 className="text-4xl md:text-5xl font-extrabold mb-8 text-slate-900" data-id="element-142">
          El Método del Sobre Digital
        </h2>

        <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-amber-100 text-left" data-id="element-143">
          <p className="text-xl text-slate-700 mb-6 leading-relaxed font-medium" data-id="element-144">
            No es una dieta financiera de hambre. Es un sistema de{' '}
            <strong className="text-amber-600" data-id="element-145">Arquitectura de Ingresos</strong>
            .
          </p>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-146">
            Basado en la sabiduría de nuestras abuelas pero adaptado a la banca
            móvil moderna, este sistema te enseña a asignar cada peso a un
            "sobre" con nombre y misión específica ANTES de gastarlo. Pasas de
            reaccionar a tu saldo a mandar sobre él.
          </p>
        </div>
      </div>
    </section>;
}